module.exports = __webpack_public_path__ + "img/cover-jeu-07.10d4a0b3.png";